import { z } from 'zod';

import { type OffsetPaginationRequestQuery } from './pagination';
import { PrimaryKeySchema } from './utils';

export const PipelineSchema = z.object({
  pipelineId: PrimaryKeySchema,
  teamId: PrimaryKeySchema,
  name: z.string().describe('The name of the pipeline'),
  description: z
    .string()
    .nullable()
    .describe('The description of the pipeline'),
  createdAt: z.coerce
    .date()
    .describe('The date and time the pipeline was created'),
  updatedAt: z.coerce
    .date()
    .describe('The date and time the pipeline was last updated'),
});

export type Pipeline = z.infer<typeof PipelineSchema>;

export const CreatePipelineSchema = PipelineSchema.pick({
  teamId: true,
  name: true,
  description: true,
});

export type CreatePipeline = z.infer<typeof CreatePipelineSchema>;

export const UpdatePipelineSchema = z.object({
  name: z.string().optional(),
  description: z.string().nullable().optional(),
});

export type UpdatePipeline = z.infer<typeof UpdatePipelineSchema>;

export const ListPipelinesOptionsSchema = z
  .object({
    teamIds: PrimaryKeySchema.array(),
    pipelineIds: PrimaryKeySchema.array(),
    nameLike: z.string().optional(),
  })
  .partial();

export type ListPipelinesOptions = z.infer<typeof ListPipelinesOptionsSchema> &
  OffsetPaginationRequestQuery<'name' | 'createdAt' | 'updatedAt'>;
